import { isNotNil } from 'ramda-adjunct';
import type { GetDataQueryResponse } from '../types/api/data';

/**
 * Returns true when `next` differs from `prev` only in `order` — i.e. the filters
 * reference and smartSearch value are both unchanged.
 *
 * `setColumnSort` spreads `state.dataQuery` preserving the original `filters` reference.
 * If only `order` changed, re-seeding `filterValues` would trigger a spurious fetchPage
 * and a duplicate `createDataQuery` POST on the server.
 *
 * Reference equality on `filters` is intentional — a new reference always means the
 * server returned fresh filter data (preset switch / initial load) and re-seeding is correct.
 */
export function isOnlyOrderChanged(prev: GetDataQueryResponse | null | undefined, next: GetDataQueryResponse): boolean {
  return isNotNil(prev) && prev.filters === next.filters && prev.smartSearch === next.smartSearch;
}